define('v3/Common/Components/ReadSpeaker/ReadSpeaker.Component',[
	'text!v3/Common/Components/ReadSpeaker/ReadSpeaker.Component.html',
	'v3/Common/Models/enums',
	'jquery',
	'lodash',
	'knockout',
	'module',
	'v3/FromV2/utils'
], function (template, enums, $, _, ko, module) {
	var config = module.config();

	function validateParams (settings) {
		if (_.isPlainObject(settings)) {
			if (!settings.readingSpeed) {
				console.error('<read-speaker> settings.readingSpeed is not defined..');
			} else if (!ko.isObservable(settings.readingSpeed)) {
				console.error('<read-speaker> settings.readingSpeed is not an observable..');
			}
			if (!settings.sentence) {
				console.error('<read-speaker> settings.sentence is not defined..');
			} else if (!ko.isObservable(settings.sentence)) {
				console.error('<read-speaker> settings.sentence is not an observable..');
			}
		} else {
			console.error('<read-speaker> settings is not defined or is not an object');
		}

		if (!_.isPlainObject(config.urls)) {
			console.error('<read-speaker> module.config().urls is not defined or is not an object');
		} else {
			if (!config.urls.api) {
				console.error('<read-speaker> module.config().urls.api is not defined');
			}
			if (!config.urls.library) {
				console.error('<read-speaker> module.config().urls.library is not defined');
			}
			if (!config.customerId) {
				console.error('<read-speaker> module.config().customerId is not defined');
			}
			if (!config.language) {
				console.error('<read-speaker> module.config().language is not defined');
			}
			if (!config.voice) {
				console.error('<read-speaker> module.config().voice is not defined');
			}
		}
	}

	function ReadSpeakerViewModel (params) {
		var self = this;
		var id = _.uniqueId();
		var settings = params.settings();

		validateParams(settings);

		self.isPlaying = ko.observable(false);

		self.sentenceId = 'readOutLoadSpeaker' + id;
		self.playId = 'readOutLoadPlay' + id;

		self.readingSpeed = settings.readingSpeed;
		self.sentence = settings.sentence;

		settings.play = function () {
			document.getElementById(self.playId).click();
		};

		settings.stop = function () {
			ReadSpeaker.PlayerAPI.stop();
		};

		self.playUrl = ko.pureComputed(function () {
			return config.urls.api.formatRaw(config.customerId, config.language, config.voice, getReadSpeakerSpeedValue(), self.sentenceId);
		});

		self.readingSpeed.subscribe(function (speed) {
			var theSpeed = (speed !== enums.readSpeakerSpeed.Fast) ? 'slow' : 'medium';
			ReadSpeaker.Common.Settings.set('hlspeed', theSpeed);
		});

		function getReadSpeakerSpeedValue () {
			return (self.readingSpeed() !== enums.readSpeakerSpeed.Fast ? '80' : '100');
		}
	}

	// Setup ReadSpeaker
	if (!window.rsConf) {
		window.rsConf = {
			settings: {
				hlicon: 'iconoff'
			},
			general: {
				usePost: true
			},
			params: config.urls.library.formatRaw(config.customerId)
		};

		// create a script element and set it's type and async attributes
		var script = document.createElement('script');
		script.src = config.urls.library.formatRaw(config.customerId);
		script.async = true;

		var createNewEvent = function (eventName) {
			var event;
			if (typeof (Event) === 'function') {
				event = new Event(eventName);
			} else {
				event = document.createEvent('Event');
				event.initEvent(eventName, true, true);
			}
			return event;
		};

		script.onload = function () {
			// Tell readspeaker library that we're done loading
			var event = createNewEvent('DOMContentLoaded');
			document.dispatchEvent(event);
		};
		document.head.appendChild(script);
	}

	return { viewModel: ReadSpeakerViewModel, template: template };
});

